module.exports = __webpack_public_path__ + "img/arrow-to-botton.1875f4ae.svg";